// extracted by mini-css-extract-plugin
export default {"country":"uF1j4itOZt2Dx8Q0BTtc","title":"xDzEw1XsN_aJ6Kf4pmZU"};